import React, { useState, useEffect, useCallback } from "react";
import { useHistory } from 'react-router-dom';
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from 'primereact/dialog';

import Ifpb from "../../assets/styles/imgs/ifpb.svg";
import Avin from "../../assets/styles/imgs/avin.svg";

import "./styles.css";

const Header = (props) => {
    const [usuario, setUsuario] = useState(props.usuario);
    const [videoajudaDialog, setVideoajudaDialog] = useState(false);
    const history = useHistory();

    useEffect(() => {
        setUsuario(props.usuario);
    }, [props.usuario]);

    const leftContents = useCallback(() => (
        <div id="header-leftContents">
            <Button onClick={() => setVideoajudaDialog(true)}>
                <i className="pi pi pi-question-circle" />
            </Button>
        </div>
    ), []);

    const rightContents = useCallback(() => (
        <div id="logo-bar">
            <span id="usuario">{usuario ? usuario.email : null}</span>
            <img id="ifpb" src={Ifpb} alt="IFPB Logo"></img>
            <Button onClick={() => history.replace({ pathname: `/` })}>
                <img id="avin" src={Avin} alt="Avin Logo"></img>
            </Button>
        </div>
    ), [usuario, history]);

    const showDialogVideoajuda = () => {
        const urlDrive = `https://drive.google.com/uc?export=download&id=${props.videoajuda}`;
        return (
            <Dialog
                closable={true}
                header="VIDEOAJUDA"
                visible={videoajudaDialog}
                style={{ width: '85vw', height: '85vw' }}
                modal
                onHide={() => setVideoajudaDialog(false)}
            >
                <div className="p-d-flex" style={{ height: '100%', width: '100%' }}>
                    <video id="videoajuda" style={{ height: '100%' }} className="p-col-12" controls autoPlay>
                        <source src={urlDrive} type='video/mp4' />
                    </video>
                </div>
            </Dialog>
        );
    };

    return (
        <>
            <div id="header">
                {showDialogVideoajuda()}
                {usuario && usuario.email ? (
                    <Toolbar id="Toolbar" left={leftContents} right={rightContents}></Toolbar>
                ) : null}
            </div>
            <div style={{ height: '4rem' }}></div>
        </>
    );
};

export default Header;



